<template>
  <div style="position: relative;">
    <gtable-crud
      ref="gtable-crud"
      :data="data"
      :pageOptions="pageOptions"
      :option="option"
      :page="page"
      :loading="loading"
      :before-open="beforeOpen"
      @searchChange="searchChange"
      @searchReset="searchReset"
      @pageChange="pageChange"
      @pageSizeChange="pageSizeChange"
      @rowDel="rowDel"
      @refresh-change="refreshChange"
    >
      <template slot="headMenuLeft">
        <my-tooltip :tooltip="$t('_components.btns.download')">
          <b-button
            :disabled="downloading"
            variant="success"
            class="btn ml-0-5 mr-0-5"
            size="sm"
            @click="handleDownload"
          >
            <feather-icon icon="DownloadIcon" size="18" />
          </b-button>
        </my-tooltip>
      </template>
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'teamName' && props.row.teamName">
          {{ props.row.teamName + "'s " + 'TEAM' }}
        </span>
      </template>
      <!-- 自定义列 -->
      <!-- slot-scope="{row,column}" -->
    </gtable-crud>

    <!-- 表单 -->
    <!-- <c-drawer
      v-model="formVisible"
      :before-close="handleBeforeClose"
    >
      <my-form
        v-if="formVisible"
        ref="formRef"
        :data="form"
        :loading="formLoading"
        :option="option"
        :footer-visible="true"
        width="auto"
        @submit="submitAdd"
      />
    </c-drawer> -->
  </div>
</template>

<script>
import MyTooltip from '@/components/myTooltip.vue'
import CDrawer from '@/components/drawer.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { BBadge, BButton } from 'bootstrap-vue'
import MyForm from '@/components/myForm/index.vue'

import {
  getListByTeam,
  workerSumExcelByTeam,
} from '@/api/worker/attendSum/index'
import { deepClone } from '@/util/util'
import { pageOptions } from '@/config/pageOption'
export default {
  name: 'MyComponent',
  components: {
    // BBadge,
    BButton,
    // CDrawer,
    // MyTooltip,
    // MyForm,
  },
  data() {
    return {
      query: {
        startDate: moment(new Date()).format('YYYY-MM'),
        endDate: moment(new Date()).format('YYYY-MM'),
      },
      page: {
        pageSize: 20,
        currentPage: 1,
        total: 12,
      },
      pageOptions: [],
      data: [],
      loading: false,
      drawerTitle: '',
      formVisible: false,
      form: {},
      type: '',
      formLoading: false,
    }
  },
  computed: {
    option() {
      const columns = [
        {
          label: this.i18n('label.employmentCode'),
          field: 'employmentCode',
          search: true,
          searchBase: true,
          formOption: {
            rules: 'required',
            editHide: true,
          },
        },
        {
          label: this.i18n('attendance.name'),
          field: 'name',
          search: true,
          searchBase: true,
          width: '150px',
          formOption: {
            rules: 'required',
            editHide: true,
          },
        },

        {
          label: 'Date',
          field: 'attendanceDate',
          type: 'monthRange',
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'yyyy-MM-dd',
          width: '130px',
          search: true,
          searchBase: true,
          formOption: {
            type: 'monthRange',
            editHide: true,
          },
        },
        {
          label: this.i18n('label.team'),
          field: 'teamId',
          type: 'select',
          dictField: 'teamName',
          dictCode: 'teams',
          search: true,
          formOption: {
            editHide: true,
            type: 'select',
            dictCode: 'teams',
          },
        },
        {
          label: this.i18n('label.projectId'),
          field: 'projectId',
          type: 'select',
          dictField: 'projectName',
          dictCode: 'project',
          search: true,
          formOption: {
            editHide: true,
            type: 'select',
            dictCode: 'project',
          },
        },
        {
          label: 'Am Sum',
          field: 'amSum',
          formOption: {
            editHide: true,
          },
        },
        {
          label: 'Pm Sum',
          field: 'pmSum',
          formOption: {
            editHide: true,
          },
        },
        {
          label: 'Ot Hours Sum',
          field: 'otHoursSum',
          formOption: {
            editHide: true,
          },
        },
        {
          label: 'Bonus Sum',
          field: 'bonusSum',
          formOption: {
            editHide: true,
          },
        },
        {
          label: this.i18n('attendanceExamine.notAttendanceDays'),
          field: 'notAttendanceDays',
          formOption: {
            editHide: true,
          },
        },
        {
          label: this.i18n('attendanceExamine.injuryDays'),
          field: 'injuryDays',
          formOption: {
            editHide: true,
          },
        },
        {
          label: this.i18n('attendanceExamine.leaveDays'),
          field: 'leaveDays',
          formOption: {
            editHide: true,
          },
        },
        {
          label: this.i18n('attendanceExamine.attendanceDays'),
          field: 'attendanceDays',
          formOption: {
            editHide: true,
          },
        },
        {
          label: this.i18n('attendanceExamine.haveAttendanceDays'),
          field: 'haveAttendanceDays',
          formOption: {
            editHide: true,
          },
        },
      ]
      const option = {
        header: true, // 显示顶部功能区(默认 true)

        addBtn: false, // 新增按钮(默认 true)
        viewBtn: false, // 显示按钮(默认 true)
        editBtn: false, // 修改按钮(默认 true)
        delBtn: false, // 删除按钮(默认 true)

        search: true, // 显示搜索(默认 true)
        menu: false, // 显示菜单(默认 true)
        menuWidth: 200, // 默认200
        form: true, // 是否使用自带form (默认true)
        // drawerWidth: 500, // 默认auto
        searchVisible: false, // 搜索默认展开(默认 false)
        fixedHeader: false, // 固定表头(默认 true)
        lineNumbers: false, // 显示每行数据的下标(默认 false)
        searchSpan: 4, // 自定义搜索栅格(默认 4)

        columns,
      }
      return option
    },
  },
  watch: {},
  mounted() {
    this.pageOptions = pageOptions
    this.onLoad(this.page)
  },
  methods: {
    async onLoad(page, params = {}) {
      this.loading = true
      const res = await getListByTeam(
        page.currentPage,
        page.pageSize,
        Object.assign(params, this.query)
      )
      const { data } = res.data
      this.page.total = data.total
      this.data = data.records
      this.loading = false
    },
    handleDownload() {
      workerSumExcelByTeam(this.query).then((res) => {
        this.getBlobObj(res.data, 'Attendence Sum.xlsx')
      })
    },
    getBlobObj(context, fileName) {
      const blob = new Blob([context])
      const a = document.createElement('a')
      const url = window.URL.createObjectURL(blob)
      a.href = url
      a.download = fileName
      a.click()
      window.URL.revokeObjectURL(url)
    },
    // i18n
    i18n(param) {
      return this.$t(`_worker.${param}`)
    },
    // 搜索按钮被点击
    async searchChange(done, e) {
      const cols = this.option.columns
      const temp = deepClone(e)
      Object.keys(temp).forEach((key) => {
        const item = temp[key]
        const col = cols.find((o) => o.field === key) || {}
        const colTypeIsRange = col.type === 'monthRange'
        if (colTypeIsRange) {
          const keyStart = key.replace(/attendanceDate/, 'startDate')
          const keyEnd = key.replace(/attendanceDate/, 'endDate')
          if (Array.isArray(item)) {
            const [start, end] = item
            temp[keyStart] = start
            temp[keyEnd] = end
            delete temp[key]
            delete this.query[key]
          }
        }
      })

      this.query = { ...temp }
      this.page.currentPage = 1
      await this.onLoad(this.page, this.query)
      done()
    },
    // 搜索重置
    searchReset() {
      this.query = {
        attendanceDate: moment(new Date()).format('YYYY-MM'),
      }
      this.onLoad(this.page)
    },
    refreshChange() {
      this.onLoad(this.page, this.query)
    },
    // 当前页改变
    pageChange(e) {
      this.page.currentPage = e
      this.onLoad(this.page)
    },
    // 页数据数量改变
    pageSizeChange(e) {
      this.page.pageSize = e
      this.onLoad(this.page)
      this.$toast({
        component: ToastificationContent,
        props: {
          title: this.$t('_default.toast.title'),
          icon: 'BellIcon',
          text: this.$t('_default.toast.text.success'),
          variant: 'success',
        },
      })
    },
    beforeOpen(done, type) {
      const formatDic = {
        add: 'Add',
        edit: 'Edit',
        view: 'View',
        upload: 'Upload',
      }
      this.drawerTitle = formatDic[type]
      done()
    },
    getStatusOption(status) {
      return this.statusOption[status] || {}
    },
    handleBeforeClose(done) {
      done()
      this.form = {}
      this.onLoad(this.page)
    },
    handleDrawerClose() {
      this.formVisible = false
      this.form = {}
      this.onLoad(this.page)
    },
    handleFormOpen(key, row = {}) {
      if (key === 'edit') {
        this.form = row
        this.type = 'edit'
      }
      this.formVisible = true
    },
  },
}
</script>
